import React from 'react';

import { ActionButton } from '@alpha/ui-lib/ui/button';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from 'utils/translationHelper';

import useStyles from './RightAlignedCta.styles';

export interface IProps {
  componentTestId?: string;
  numberOfValidPayments?: number;
  submitPayments?: () => void;
  cancelUpload?: () => void;
  isValidFxLimit?: boolean;
  fundingMethodValid?: boolean;
  isSubmitting?: boolean;
  isInvalid?: boolean;
  pendingVOPReview?: boolean;
}

const RightAlignedCta: React.FC<IProps> = (props: IProps) => {
  const {
    componentTestId,
    numberOfValidPayments,
    submitPayments,
    cancelUpload,
    isValidFxLimit,
    fundingMethodValid = false,
    isSubmitting = false,
    isInvalid = false,
    pendingVOPReview = false,
  } = props;


  const styles = useStyles();

  return (
    <div data-testid={componentTestId} className={styles.rightAlignedCtas}>
      <ActionButton
        onClick={cancelUpload}
        size="medium"
        style={{ background: '#A62B231A', color: '#A62B23' }}
        disabled={isSubmitting}
      >
        {t('cancel_upload')}
      </ActionButton>
      {(numberOfValidPayments && numberOfValidPayments > 0) ? (
        <div className={styles.submitButtonContainer}>
          <ActionButton
            onClick={submitPayments}
            disabled={!fundingMethodValid || isSubmitting || !isValidFxLimit || isInvalid || pendingVOPReview}
            loading={isSubmitting}
          >
            {`${t('submit_valid_payment')} (${numberOfValidPayments || '-'})`}
          </ActionButton>
        </div>
      ) : null}
    </div>
  );
};

export default RightAlignedCta;
